<template>
    <div class="row" id="messages-row">
        <div class="messages col-md-12" id="main-messages">
            <div class="message-container" v-for="message in messages" :key="message.id" :id="message.id">
                <div class="alert" :class="{
                    'alert-dismissible': message.dismissible === true,
                    'alert-info': message.type === 'info',
                    'alert-danger': message.type === 'danger',
                    'alert-success': message.type === 'success'
                    }" role="alert">
                    <div class="msg-inner">
                        <button type="button" class="msg-close-button close" v-if="message.dismissible === true" @click="clearMessage(message)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="msg-headline" v-if="message.headline.length > 0">
                            {{message.headline}}
                            <span class="fa fa-check" aria-hidden="true" v-if="message.check"></span>
                        </h4>
                        <p class="msg" v-html="message.text"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Messages from '../classes/message';
const msg = new Messages();
export default {
    name: 'messages',
    data() {
        return { messages: msg.getMessages() };
    },
    methods:  {
        clearMessage(message) {
            msg.clearMessage(message);
        }
    },
    computed: mapGetters({
        balance: 'totalBalance'
    })
};
</script>

<style scoped lang="less">
#messages-row {
    position: fixed;
    width:    100%;
    z-index:  3;
    margin:   0;
}

#main-messages {
    position: absolute;
    left:     0;
    z-index:  1099;
    width:    100%;
    margin:   0;
    padding:  0;

    .alert {
        margin:        0;
        border-radius: 0;
        padding:       0;
    }
    .msg-inner {
        padding:    10px 10px 0 10px;
        text-align: center;
    }
}

.messages {
    position: fixed;
    left:     15px;
    top:      51px;
    z-index:  999;

    .message-container {
        opacity:    1;
        transition: opacity 800ms ease 300ms;
        max-height: 200px;
        overflow:   hidden;
        &.fadeout {
            opacity:    0;
            max-height: 0;
            transition: opacity 800ms ease 300ms, max-height 600ms ease;
        }
    }
    .msg-headline {
        margin-top: 0;
        font-size:  1.8em;
    }
    .message {
        overflow: hidden;
    }
    .close:focus {
        outline: none;
    }
}
</style>
